import React from "react";
import { Toggle, RaisedButton, TextField } from "material-ui";

import connectToStores from "alt-utils/lib/connectToStores";
import AppStore from "../stores/AppStore";
import AppActions from "../actions/AppActions";

@connectToStores
class Admin extends React.Component {
  static getStores() {
    return [AppStore];
  }

  static getPropsFromStores() {
    return AppStore.getState();
  }

  getStyles() {
    return {
      container: {
        margin: "40px auto",
        maxWidth: 300,
        textAlign: "center"
      },
      button: {
        marginTop: 30
      },
      toggle: {
        width: 300,
        marginBottom: 5,
        textAlign: "left"
      },
      code: {
        width: 300
      }
    };
  }

  static get contextTypes() {
    return {
      router: React.PropTypes.object.isRequired
    };
  }

  render() {
    var styles = this.getStyles();

    return (
      <div style={styles.container}>
        <Toggle
          checked={this.props.isPreviewMode}
          style={styles.toggle}
          label="Preview mode"
          onToggle={() => AppActions.setPreviewMode(!this.props.isPreviewMode)}
        />

        <Toggle
          checked={this.props.isAdvanceSingleTicketsMode}
          style={styles.toggle}
          label="Advance single tickets mode"
          onToggle={() =>
            AppActions.setAdvanceSingleTicketsMode(
              !this.props.isAdvanceSingleTicketsMode
            )
          }
        />

        <Toggle
          checked={this.props.isKioskMode}
          style={styles.toggle}
          label="Kiosk mode"
          onToggle={() => AppActions.setKioskMode(!this.props.isKioskMode)}
        />

        <TextField
          floatingLabelText="Kiosk code"
          value={this.props.kioskCode}
          style={styles.code}
          onChange={e => AppActions.setKioskCode(e.target.value)}
        />

        <RaisedButton
          label="Return to schedule"
          style={styles.button}
          onClick={() => this.context.router.push("/schedule")}
        />
      </div>
    );
  }
}

export default Admin;



// WEBPACK FOOTER //
// ./src/app/components/admin.jsx